import { TranslateService } from '@ngx-translate/core';
import {
  CommunityProfileWidgetConfig,
  DROPOFF_VERIFIABLE_PROPERTIES,
} from '@trp/community/interfaces';
import { DropoffProgram } from '@trp/nationaldb/interfaces';

const dropoffPrograms = (
  translateService: TranslateService,
): CommunityProfileWidgetConfig['dropoffPrograms'] => ({
  section: 'dropoffPrograms',
  title: 'widgets.dropoffProgram.title',
  maxColumns: 3,
  propertiesToVerify: [...DROPOFF_VERIFIABLE_PROPERTIES],
  widgets: [
    {
      section: 'dropoffPrograms',
      infoType: 'programUrl',
      type: 'standard',
      locations: ['community-profile', 'map-profile'],
      title: 'widgets.dropoffProgram.programUrl',
      icon: 'global:search',
      infoText: 'requestForm.questions.general.onlineToolForAcceptedMaterialsInfo',
      availableValueFormat: 'html',
      ifInfoAvailable: (info: DropoffProgram) => !!info.programUrl,
      availableResolver: (info: DropoffProgram) =>
        `<a href="${info.programUrl}" class="link" target="_blank">${info.programUrl}</a>`,
      unavailableResolver: () =>
        translateService.instant(
          'widgets.dropoffProgram.notice.noProgramUrl'
        ),
    },
    {
      section: 'dropoffPrograms',
      infoType: 'pdfUrl',
      type: 'standard',
      locations: ['community-profile', 'map-profile'],
      title: 'widgets.dropoffProgram.pdfUrl',
      icon: 'custom-solid:RoundedContentBallot',
      infoText: 'requestForm.questions.general.pdfUrlInfo',
      availableValueFormat: 'html',
      ifInfoAvailable: (info: DropoffProgram) => !!info.pdfUrl,
      availableResolver: (info: DropoffProgram) =>
        `<a href="${info.pdfUrl}" class="link" target="_blank">${info.pdfUrl}</a>`,
      unavailableResolver: () =>
        translateService.instant(
          'widgets.dropoffProgram.notice.noPdfUrl'
        ),
    },
    {
      section: 'dropoffPrograms',
      infoType: 'guidelinesUrl',
      type: 'standard',
      locations: ['community-profile', 'map-profile'],
      title: 'widgets.dropoffProgram.guidelinesUrl',
      icon: 'global:alternate-email',
      infoText: 'requestForm.questions.general.webpageForAcceptedMaterialInfo',
      availableValueFormat: 'html',
      ifInfoAvailable: (info: DropoffProgram) => !!info.guidelinesUrl,
      availableResolver: (info: DropoffProgram) =>
        `<a href="${info.guidelinesUrl}" class="link" target="_blank">${info.guidelinesUrl}</a>`,
      unavailableResolver: () =>
        translateService.instant(
          'widgets.dropoffProgram.notice.noGuidelinesUrl'
        ),
    },
  ],
});

export default dropoffPrograms;
